module.exports = __webpack_public_path__ + "static/media/white.46270894.svg";